import React from 'react'

export default function RubricMarker({ className, color }) {
  return (
    <span
      className={className}
      style={{ fill: color }}
      dangerouslySetInnerHTML={{
        __html: `
<svg viewBox="-370 248.28 100 100">
  <path stroke="#ffffff" stroke-width="3" d="M-319.999,344.28c-0.24,0-0.48-0.086-0.671-0.258c-0.186-0.168-18.594-16.833-24.085-22.549 c-9.604-9.992-14.273-19.858-14.273-30.162c0-21.522,17.508-39.031,39.029-39.031s39.026,17.509,39.026,39.031 c0,10.921-5.402,21.635-16.521,32.755c-1.777,1.782-21.016,19.214-21.834,19.955C-319.518,344.194-319.759,344.28-319.999,344.28z" />
</svg>`
      }}
    />
  )
}
